export default {
  title: {
    regular: 'Modificadores regulares para productos',
    meal: 'Crea tu artículo de menú combinado',
    upsell: 'Crea tu grupo de venta adicional',
  },
  description: {
    regular:
      'Selecciona los modificadores que se incluirán en el nuevo grupo si ya existen en otro grupo. También puedes crear el grupo ahora y añadir nuevos modificadores después.',
    meal: 'Selecciona los productos que se incluirán en tu artículo combinado. Si aún no existen, créalos en la página «Gestionar menús». Asegúrate de adjuntar el artículo combinado a los productos correspondientes en la sección «Modificadores» del editor de productos.',
    upsell:
      'Selecciona los productos que se incluirán en tu grupo de venta adicional. Si aún no existen, créalos en la página «Gestionar menús». Asegúrate de adjuntar el artículo de venta adicional a los productos correspondientes en la sección «Modificadores» del editor de productos.',
  },
  fields: {
    name: {
      label: 'Nombre',
      placeholder: 'Introduce el nombre del grupo',
    },
    max_quantity: {
      label: 'Cantidad máx.',
      placeholder: 'Cantidad máx. de modificadores',
    },
    is_required: {
      label: 'Obligatorio',
    },
  },
  labels: {
    visible: 'Visible',
    hidden: 'Oculto',
    multiply: 'Multiplicable',
  },
  buttons: {
    save: 'Guardar',
    close: 'Cerrar',
  },
  toasts: {
    modifier_group_got_created: 'Grupo de modificadores creado',
    modifier_group_got_updated: 'Grupo de modificadores actualizado',
  },
};
